import { CustomerState } from "../customer.slice.ts";
import { PayloadAction } from "@reduxjs/toolkit";
import { VatNumberRequest } from "../../../../orchestrator-api-client";

export const submitVatNumberReducer = (
  state: CustomerState,
  action: PayloadAction<VatNumberRequest>,
) => {
  state.job.vatNumber = action.payload.vatNumber;
};
